import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { MethodSection } from '../components/MethodSection';
import { IncludesSection } from '../components/IncludesSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-193">
      <Hero data-id="element-194" />
      <ProblemSection data-id="element-195" />
      <MethodSection data-id="element-196" />
      <IncludesSection data-id="element-197" />
      <PricingSection data-id="element-198" />
      <FAQSection data-id="element-199" />
      <Footer data-id="element-200" />
    </div>;
}